import { render, staticRenderFns } from "./ListaRealizados.vue?vue&type=template&id=78b5bfc7&"
import script from "./ListaRealizados.vue?vue&type=script&lang=js&"
export * from "./ListaRealizados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports